import { z } from "zod";

export const newProjectSchema = z.object({
  name: z.string().min(1, { message: "Name is required" }),
  projectTemplateSlug: z.string().min(1, { message: "Project template is required" }),
  description: z.string().optional(),
  chaptersInstructions: z.record(z.string(), z.string()),
  projectInstructions: z.string().optional(),
  decisionContext: z.string().optional(),
  successMetrics: z.string().optional(),
  targetAudience: z.string().optional(),
  additionalContext: z.string().optional(),
  language: z.string().default("english"),
  presentationPrompt: z.string().optional(),
  dimensionValues: z.record(z.string(), z.string()).optional()
});
